<table>
  <thead><tr><td>
    <div class="header-space">&nbsp;{{ 'ROUTE_REPORT.PRINTING.DOCUMENT_PRINTING' | translate }}</div>
  </td></tr></thead>
  <tbody><tr><td>
    <div class="content">
  <router-outlet></router-outlet>
</div>
  </td></tr></tbody>
  <tfoot><tr><td>
    <div class="footer-space">&nbsp;</div>
  </td></tr></tfoot>
</table>

<div class="header">_</div>
<div class="footer"><span>Mobiis - {{data | date:'dd/MMM/yyyy - HH:mm:ss'}}</span></div>
